export enum CalendarFilterPeriod {
  Week = 'week',
  Month = 'month',
}

export enum DatepickerSearchPeriod {
  Checkin = 'checkin',
  Checkout = 'checkout',
}

export type CalendarFilterPeriodType = CalendarFilterPeriod.Week | CalendarFilterPeriod.Month;
